import React from 'react';
import PropTypes from 'prop-types';

import MessageDecorate from './MessageDecorate';
import styles from './ImageMessage.scss';

ImageMessage.propTypes = {
    ...MessageDecorate.propTypes,
    text: PropTypes.string,
    thumbnailUrl: PropTypes.string,
    mediaUrl: PropTypes.string.isRequired,
};

export default function ImageMessage({ text, mediaUrl, thumbnailUrl, ...rest }) {
    return (
        <MessageDecorate
            styles={{
                message: styles.message,
                timestamp: styles.timestamp,
            }}
            {...rest}
        >
            <a className={styles.link} href={mediaUrl} target="__blank">
                <img className={styles.image} src={thumbnailUrl || mediaUrl} alt={text} />
            </a>
            {text && <p className={styles.text}>{text}</p>}
        </MessageDecorate>
    );
}
